export default __webpack_public_path__ + "static/media/ws.81cbff3d.svg";